import type { DiagnosticTabProps } from "@/components/projects/diagnostic/DiagnosticSection";
import type { ScopeItemsBasis } from "@/hooks/useDiagnosticScopeItems";

import { scopeItemsTile } from "../data/scopeItems";

/**
 * A base que o tile "Scope items ativos" contou, para os detalhes do Ato 1 e do
 * Ato 2 lerem a mesma população: a versão aprovada (com Calibragem publicada, a
 * do carimbo dela), ou `null` para a curadoria salva. Sem número no tile, não há
 * base, e os detalhes não pedem nada.
 */
export function scopeItemsBasis(
  validation: DiagnosticTabProps["validation"],
): ScopeItemsBasis | undefined {
  const tile = scopeItemsTile(validation);
  return tile.kind === "counted"
    ? { approvalVersion: tile.basis === "approved" ? tile.approvalVersion : null }
    : undefined;
}
